// extracted by mini-css-extract-plugin
module.exports = {"countdown":"BaseCountdown_countdown_2CjgB","digit":"BaseCountdown_digit_1cUNr"};